const isObject = (object) => object !== null && typeof object === 'object';

const isEquals = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

function getKeyByValue(object, propertyName, value) {
    return Object.keys(object).find((key) => object[key][propertyName] === value);
}

const filterUndefined = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== undefined));

const objectUtil = {
    isEquals,
    isObject,
    getKeyByValue,
    filterUndefined,
};

export default objectUtil;
